module.exports = __webpack_public_path__ + "static/media/net1.73309712.gif";